export enum BusinessAccidentType {
  PROFESSIONAL = 'PROFESSIONAL',
  COMMUTING = 'COMMUTING',
  LEISURE = 'LEISURE',
}

export const getBusinessAccidentTypeLabel = (object: BusinessAccidentType) => {
  switch (object) {
    case BusinessAccidentType.PROFESSIONAL:
      return $localize`Au travail`;
    case BusinessAccidentType.COMMUTING:
      return $localize`Trajet`;
    case BusinessAccidentType.LEISURE:
      return $localize`Loisir`;
    default:
      return '';
  }
};
